<template>
  <div>
    <v-row
      justify=center
      no-gutters
      class="main--text">
      <v-col
        cols=auto>
        <h4>{{student.fullName()}} さんの担当</h4>
        <v-card
          width=800>
          <v-container
            fluid>
            <v-row
              no-gutters
              justify=start
              align=center>
              <v-col>
                <h3>先生プロフィール画面</h3>
              </v-col>
              <v-col
                cols=auto>
                <v-icon
                @click="$emit('close-button-click')">mdi-close</v-icon>
              </v-col>
            </v-row>
            <v-row
              dense>
              <v-col
                md=3
                sm=4
                cols=12>
                <v-container
                  fluid>
                  <v-row
                    justify=center
                    justify-sm=end
                    justify-md=end>
                    <v-col
                      cols=auto>
                      <v-avatar
                        size="111px">
                        <img
                          :src="teacher.iconUrl"
                          alt=""
                          >
                      </v-avatar>
                    </v-col>
                  </v-row>
                  <div  style="text-align:right">
                    <h2 :class="leftItemsStyle">{{ teacher.fullName() }}</h2>
                    <p :class="leftItemsStyle">
                      {{ teacher.flatFullName() }}<br>
                      {{ teacher.genderInJapanese() }}<br>
                    <v-tooltip
                      left>
                      <template v-slot:activator="{ on }">
                      <v-btn
                        icon
                        v-on="on"
                        @click="$emit('offer-button-click')"
                        ><v-icon>fa-chalkboard-teacher</v-icon>
                      </v-btn>
                      </template>
                      <span>授業を依頼する</span>
                    </v-tooltip>
                    <v-tooltip
                      left>
                      <template v-slot:activator="{ on }">
                      <v-btn
                        icon
                        v-on="on"
                        @click="$emit('message-button-click')"
                        ><v-icon>far fa-comments</v-icon></v-btn>
                      </template>
                      <span>メッセージ画面を開く</span>
                    </v-tooltip>
                    <br><br>
                    <v-tooltip
                      left>
                      <template v-slot:activator="{ on }">
                        <v-btn
                          icon
                          small
                          v-on="on"
                          @click="confirmBreakOff=true"
                          ><v-icon>mdi-account-minus-outline</v-icon></v-btn>
                      </template>
                      <span>担当を解除する</span>
                    </v-tooltip>
                    </p>
                  </div>
                </v-container>
              </v-col>
              <v-col
                md=8
                sm=8
                xs=12>
                <v-container
                  fluid>
                  <h5>自己PR</h5>
                  <p class="line--feed">{{ teacher.selfIntroduction }}</p>
                  <br>
                  <h5>学歴</h5>
                  <p>{{ teacher.universityInfo() }}</p>
                  <h5>希望時給</h5>
                  <p>{{teacher.expectedWage}}円</p>
                  <h5>対応可能スケジュール</h5>
                  <v-chip
                    v-for="(schedule, index) in teacher.availableSchedulesToStrings()"
                    :key="index"
                    outlined>{{schedule}}</v-chip>
                </v-container>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog
      :value="confirmBreakOff"
      width=350
      >
      <v-card
        class="main--text">
        <v-container>
          <v-row
            justify=center>
            <v-col
              cols=auto>
              <span>{{teacher.fullName()}} 先生の担当を解除しますか</span>
            </v-col>
          </v-row>
          <v-row
            justify=center>
            <v-col
              cols=auto>
              <v-btn
                rounded
                outlined
                depressed
                @click="confirmBreakOff=false"
                >閉じる</v-btn>
            </v-col>
            <v-col
              cols=auto>
              <v-btn
                rounded
                outlined
                depressed
                color="grey"
                @click="breakOff"
                >解消する</v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    teacher: {
      type: Object,
      required: true
    },
    student: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      confirmBreakOff: false,
      leftItemsStyle: "text-center text-sm-right text-md-right"
    }
  },
  methods: {
    breakOff () {
      this.confirmBreakOff = false
      this.$emit('break-button-click')
    }
  }
}
</script>
